import HomeBanner from "../components/HomeBanner";
import { ImageRevealer } from "../components/ImageRevealer";

export default function Home() {
  // Hardcoded homepage images (previously fetched from Strapi CMS)
  const images = [
    '/images/se_img_1.jpg',
    '/images/se_img_2.jpg',
    '/images/se_img_3.jpg',
    '/images/se_img_4.jpg',
    '/images/se_img_5.jpg',
    '/images/se_img_6.jpg',
    '/images/se_img_7.jpg',
    '/images/se_img_8.jpg'
  ];

  return (
    <main>
      <HomeBanner page="website" />
      <ImageRevealer images={images}/>
    </main>
  );
}